__turbopack_context__.v({
  "bottom-content": "style-module-scss-module__BcGBna__bottom-content",
  "close-icon": "style-module-scss-module__BcGBna__close-icon",
  "container": "style-module-scss-module__BcGBna__container",
  "content": "style-module-scss-module__BcGBna__content",
  "description": "style-module-scss-module__BcGBna__description",
  "form-container": "style-module-scss-module__BcGBna__form-container",
  "main-text": "style-module-scss-module__BcGBna__main-text",
  "notification": "style-module-scss-module__BcGBna__notification",
  "title": "style-module-scss-module__BcGBna__title",
});
